import { FC } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
} from '@chakra-ui/react';
import { useAddDetailStore } from '../../../hooks';
import {
  AdhocSupportedIntervalCheckboxGroup,
  ConfigTemplateTextarea,
  DescriptionTextarea,
  ReleasedAtDatepicker,
  ReleasedChannelCheckboxGroup,
  VersionInput,
} from '../../Forms';

type Props = ReturnType<typeof useAddDetailStore>['form'] & {
  handleConfirm: () => void;
};

export const CrawlerAddDetailInputModalView: FC<Props> = ({
  control,
  register,
  formState,
  handleConfirm,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">バージョンの追加</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl isRequired isInvalid={!!formState.errors.version}>
          <FormLabel>バージョン</FormLabel>
          <VersionInput name="version" register={register} w="240px" />
          <FormErrorMessage>
            {formState.errors.version?.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.description}>
          <FormLabel>説明</FormLabel>
          <DescriptionTextarea
            name="description"
            register={register}
            rows={4}
          />
          <FormErrorMessage>
            {formState.errors.description?.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.releasedAt}>
          <FormLabel>リリース日</FormLabel>
          <ReleasedAtDatepicker
            name="releasedAt"
            control={control}
            inputProps={{ width: '240px' }}
          />
          <FormErrorMessage>
            {formState.errors.releasedAt?.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl>
          <FormLabel>手動実行対応</FormLabel>
          <AdhocSupportedIntervalCheckboxGroup
            name="adhocSupportedIntervals"
            control={control}
          />
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.configTemplate}>
          <FormLabel>UI表示テンプレート</FormLabel>
          <ConfigTemplateTextarea
            name="configTemplate"
            register={register}
            rows={8}
          />
          <FormErrorMessage>
            {formState.errors.configTemplate?.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.releasedChannel}>
          <FormLabel>リリースチャンネル</FormLabel>
          <ReleasedChannelCheckboxGroup
            name="releasedChannel"
            control={control}
            isInvalid={!!formState.errors.releasedChannel}
          />
          <FormErrorMessage>
            {
              // eslint-disable-next-line
              (formState.errors.releasedChannel as any)?.message
            }
          </FormErrorMessage>
        </FormControl>
      </Stack>
    </ModalBody>
    <ModalFooter justifyContent="center" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        onClick={handleConfirm}
        isDisabled={!formState.isValid}
      >
        確認
      </Button>
    </ModalFooter>
  </ModalContent>
);
